<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-08 17:38:25
 * @LastEditors: HG
 * @LastEditTime: 2019-08-13 16:16:01
 -->
<template>
  <div class="container">
    <head-nav-bar title="住院预交金充值" :fixed="true" />
    <div class="mt-header-nav">
      <cell-box style="padding: 0.3rem 0;" :column="2">
        <cell-item label="姓名：" :value="info.PatientName" />
        <cell-item label="住院日期：" :value="info.InDate" />
        <cell-item label="科室：" :value="info.DepartmentName" />
        <cell-item label="床位：" :value="info.BedNo" />
      </cell-box>
      <div class="kong"></div>
      <div class="money-box flex">
        <span class="meony-symbol">￥</span>
        <van-cell-group class="flex-item">
          <van-field
            v-model="moeny"
            type="number"
            size="large"
            placeholder="请输入缴费金额"
            style="font-size:0.6rem;"
          />
        </van-cell-group>
      </div>
      <div class="box money-select">
        <van-grid :column-num="3" :gutter="10">
          <van-grid-item
            class="money-select-item"
            v-for="(value, index) in moneyList"
            :key="index"
            :text="value + '元'"
            @click="setMoney(value)"
          />
        </van-grid>
      </div>
      <div class="box" style="margin-top:1rem">
        <van-button type="info" block @click="onSubmit">确认缴费</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, CellGroup, Grid, GridItem, Button } from "vant";
import { CellBox, CellItem } from "@/components/cell";

export default {
  name: "Detailed",
  components: {
    CellBox,
    CellItem,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button
  },
  computed: {},
  data() {
    return {
      DiagnosisCardNo: "",
      info: {},
      moeny: "",
      moneyList: [0.01, 200, 500, 800, 1000, 1500, 2000, 3000, 5000, 10000]
    };
  },
  created() {
    this.DiagnosisCardNo = this.$route.query.DiagnosisCardNo;
    if (this.DiagnosisCardNo) {
      this.getInfo(this.DiagnosisCardNo);
    }
  },
  methods: {
    getInfo(DiagnosisCardNo) {
      this.$post("InHospital_Info", {
        DiagnosisCardNo: DiagnosisCardNo
      }).then(res => {
        this.info = res.Data;
      });
    },
    onSubmit() {},
    setMoney(value) {
      this.moeny = value;
    }
  }
};
</script>

<style lang="less">
.money-box {
  padding: 0.3rem;
  margin-top: 0.5rem;
  .meony-symbol {
    font-size: 0.6rem;
    color: #999;
    line-height: 1.3rem;
  }
}
.money-select {
  .money-select-item div::after {
    border: 1px solid @main-color;
  }
}
</style>
